<template>
  <b-container fluid>
    <b-card>
      <b-form>
        <b-row>
          <b-col md="4">
            <b-form-group label="Escolha uma data:">
              <b-form-input
                type="date"
                v-model="tempDate"
              />
            </b-form-group>
          </b-col>

          <b-col md="2" class="d-flex align-items-center mt-1">
            <b-button
              variant="primary"
              @click="onSubmit"
              :disabled="loadingTable || loadingExtract || loadingLiquidation"
            >
              <span v-if="!loadingTable && !loadingExtract && !loadingLiquidation ">CONSULTAR</span>
              <span v-else >Carregando... </span>
            </b-button>
          </b-col>
        </b-row>

        <p v-if="dateError" class="text-center text-danger">
          A data escolhida é inválida.
        </p>
        <p
          v-if="
            selectedDate &&
            !dateError &&
            !loadingTable &&
            !loadingExtract &&
            !loadingLiquidation &&
            ((tableData.items1 && tableData.items1.length === 0) ||
              (tableData.items2 && tableData.items2.length === 0) ||
              (items3 && items3.length === 0))
          "
          class="text-center text-warning mt-3"
        >
          Alguns dados não foram encontrados para a data selecionada.
        </p>
      </b-form>
    </b-card>

    <SettlementRequests
      ref="requests"
      :date="selectedDate"
      @loaded="dropdownOptions = $event"
      @load="handleSummary"
      @tableDataLoaded="handleTableData"
      @tableExtractLoaded="handleExtractData"
      :loadingLiquidation="loadingLiquidation"
      :loadingTable="loadingTable"
      :loadingExtract="loadingExtract"
      @update:loadingLiquidation="loadingLiquidation = $event"
      @update:loadingTable="loadingTable = $event"
      @update:loadingExtract="loadingExtract = $event"
    />
    <SettlementSummary
      :total="summaryData.total"
      :valueFirstPeriod="summaryData.valueFirstPeriod"
      :valueSecondPeriod="summaryData.valueSecondPeriod"
      :selectedDate="selectedDate"
      @refresh-data="refetchRequests"
    />
    <Tables
      :items1="tableData.items1"
      :items2="tableData.items2"
      :items3="items3"
      :dropdownOptions="dropdownOptions"
      :dropdownOptionsExtract="dropdownOptionsExtract"
      :selectedEC.sync="selectedEC"
      :loadingLiquidation="loadingLiquidation"
      :loadingTable="loadingTable"
      :loadingExtract="loadingExtract"
      :rawTableData="rawTableData"
      :rawExtractData="rawExtractData"
    />
  </b-container>
</template>

<script>
import SettlementRequests from "./Requests/SettlementRequests.vue";
import SettlementSummary from "./SettlementSummary.vue";
import Tables from "./Tables/Tables.vue";
import { BContainer, BCard, BForm, BFormInput, BRow, BCol, BFormGroup,BButton} from "bootstrap-vue";

export default {
  components: { BContainer, BCard, BForm, BFormInput, BRow, BCol, BFormGroup, SettlementSummary, Tables, SettlementRequests,BButton},
  data() {
    return {
      selectedDate: "",
      tempDate: "",
      dateError: false,
      selectedEC: null,
      dropdownOptions: ["Nenhuma opção disponível"],
      dropdownOptionsExtract: ["Nenhuma opção disponível"],
      summaryData: {
        total: 0,
        valueFirstPeriod: 0,
        valueSecondPeriod: 0,
      },
      tableData: [],
      rawTableData: [],
      rawExtractData: [],
      items3: [],
      loadingLiquidation: false,
      loadingTable: false,
      loadingExtract: false,
    };
  },
  methods: {
    onSubmit() {
      if (this.tempDate && this.tempDate.length === 10) {
        const selected = new Date(this.tempDate);
        const today = new Date();
        if (selected > today) {
          this.dateError = true;
          return;
        }
        this.dateError = false;
        this.selectedDate = this.tempDate; 
        this.refetchRequests();
      } else {
        this.dateError = true;
      }
    },

    refetchRequests() {
      if (!this.selectedDate || this.dateError) return;

      this.$refs.requests.fetchData(this.selectedDate);
      this.$refs.requests.fetchTableData(this.selectedDate);
      this.$refs.requests.fetchExtractData(this.selectedDate);
    },

    handleTableData(data) {
      if (!Array.isArray(data) || data.length === 0) {
        this.tableData = { items1: [], items2: [] };
        this.dropdownOptions = [
          { value: null, text: "Nenhuma opção disponível" },
        ];
        return;
      }

      this.rawTableData = data;

      const items1 = data
        .map((item) => {
          const rawDif = item.extractLiquidationDif?.dif ?? 0;
          const dif = parseFloat(String(rawDif).replace(",", ".")) || 0;
          return {
            ec: item.ec,
            nome: item.name,
            diferença: dif,
          };
        })
        .filter((item) => item.diferença !== 0);

      const items2 = data
        .map((item) => {
          const rawDif = item.extractPaymentDif?.dif ?? 0;
          const dif = parseFloat(String(rawDif).replace(",", ".")) || 0;
          return {
            ec: item.ec,
            nome: item.name,
            diferença: dif,
          };
        })
        .filter((item) => item.diferença !== 0);

      const uniqueECs = [...new Set(data.map((item) => item.ec))];
      const ECs = [
        { value: null, text: "Selecione um EC..." },
        ...uniqueECs.map((ec) => ({
          value: ec,
          text: `EC ${ec}`,
        })),
      ];

      this.tableData = { items1, items2 };
      this.dropdownOptions = ECs;
    },

    handleExtractData(data) {
      if (!data || Object.keys(data).length === 0) {
        this.items3 = [];
        this.dropdownOptionsExtract = [
          { value: null, text: "Nenhuma opção disponível" },
        ];
        return;
      }

      this.rawExtractData = data;
      const items3 = [];

      Object.values(data).forEach((ecObject) => {
        Object.entries(ecObject).forEach(([ec, value]) => {
          items3.push({
            ec,
            nome: value.data?.[0]?.name || "",
            diferença: value.dif ?? 0,
          });
        });
      });

      const uniqueECs = [...new Set(items3.map((item) => item.ec))];
      const ECsExtract = [
        { value: null, text: "Selecione um EC..." },
        ...uniqueECs.map((ec) => ({
          value: ec,
          text: `EC ${ec}`,
        })),
      ];

      this.items3 = items3;
      this.dropdownOptionsExtract = ECsExtract;
    },

    handleSummary(data) {
      this.summaryData = data;
    },
  },
};
</script>
